/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react'
import { KelmanDraggable, KelmanDraggableSimulation } from '@phaco3d/kelman'
import { useInjuries } from '../../providers/InjurySimulation'
import ScenariosButton from '../Scenarios/ScenariosButton'

const InjurySimulator: React.FC = () => {
  const [simulationImage, setSimulationImage] = React.useState<string>(
    '/snellen.png'
  )

  const { injuries } = useInjuries()

  const handleChange = (url: string) => {
    setSimulationImage(url)
  }

  return (
    <>
      <div style={{ display: 'flex', height: '100vh' }}>
        <KelmanDraggableSimulation
          simulationImage={simulationImage}
          simulationContainer={{
            width: '100%',
            height: '100vh'
          }}
        >
          {injuries !== undefined &&
            injuries.map(injury => {
              if (!injury.active) {
                return ''
              }
              if (!injury.movable) {
                return <div key={injury.name} style={injury.simulation} />
              }
              return (
                <KelmanDraggable
                  key={injury.name}
                  position={injury.controlledPosition}
                  disabled
                >
                  <div style={injury.simulation} />
                </KelmanDraggable>
              )
            })}
        </KelmanDraggableSimulation>
      </div>
      <ScenariosButton handleScenarioChange={handleChange} />
    </>
  )
}

export default InjurySimulator
